import '@uirouter/angularjs';
import '@uirouter/react';
import './decorateUIRouterViewConfigs';
import './angularjs/ReactUIViewAdapterComponent';
import './react/UIViewMonkeyPatch';
export * from './angularjs/module';
export * from './react/UIRouterReactContext';
export * from './react/UIRouterReactContextDecorator';
//# sourceMappingURL=index.js.map